import {useState} from 'react';
import {
  Money,
  ProductOptionsProvider,
  flattenConnection,
} from '@shopify/hydrogen';
import {useErrorLogger} from '@shopify/react-bugsnag';
import ProductModal from '../ProductModal/ProductModal.client';
import {usePageContext} from '../../contexts/PageContext.client';
import {MonorailEvent, trackEvent} from '../../utils/monorail.client';
import {LinkType} from 'shared/types';
import {CardStyle} from 'shared/utils/CardStyleUtil';
import {ProductLinkCard} from './ProductLinkCard';
import {base64Decode} from 'shared/utils/base64';

export default function ShoppableLink({
  id,
  title,
  product,
  style,
}: {
  id: string;
  title: string;
  product: unknown;
  style: CardStyle;
}) {
  // @ts-expect-error TODO: type definition for `product`
  const productImage = flattenConnection(product.images)[0]?.transformedSrc;
  // @ts-expect-error TODO: type definition for `product`
  const firstVariant = flattenConnection(product.variants)[0];
  // @ts-expect-error TODO: type definition for `product`
  const imageExists = productImage || firstVariant?.image?.url;

  const [isOpen, setIsOpen] = useState(false);

  const pageCtx = usePageContext();
  const logger = useErrorLogger();

  function openModal() {
    setIsOpen(true);
    trackEvent({
      event: MonorailEvent.ClickLink,
      data: {
        linkId: id,
        linkTitle: title,
        pageId: pageCtx.id,
        // @ts-expect-error TODO: type definition for `product`
        productId: base64Decode(product.id),
        linkType: LinkType.ShoppableLink,
      },
    })?.catch((error) => {
      logger.notify(
        new Error(
          `event tracking error: ${MonorailEvent.ClickLink}: ${error.message}`,
        ),
      );
    });
  }

  function closeModal() {
    setIsOpen(false);
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === 'Enter') {
      event.preventDefault();
      openModal();
    }
  }

  return (
    <>
      <ProductLinkCard
        data-testid="shoppable-link-click"
        title={title}
        // @ts-expect-error TODO: type definition for `product`
        image={productImage || firstVariant?.image?.url}
        // @ts-expect-error TODO: type definition for `product`
        description={product.description}
        // @ts-expect-error TODO: type definition for `product`
        price={<Money data={firstVariant?.priceV2} />}
        style={style}
        onClick={openModal}
        onKeyDown={handleKeyDown}
      />
      <ProductOptionsProvider
        // @ts-expect-error TODO: fix typing for Product
        data={product}
        // @ts-expect-error TODO: fix typing for Product
        initialVariantId={base64Decode(firstVariant?.id) || undefined}
      >
        <ProductModal
          show={isOpen}
          closeModal={closeModal}
          product={product}
          title={title}
        />
      </ProductOptionsProvider>
    </>
  );
}
